import { render, staticRenderFns } from "./RuleLinkSuccessModal.vue?vue&type=template&id=60f37f77&"
import script from "./RuleLinkSuccessModal.vue?vue&type=script&lang=js&"
export * from "./RuleLinkSuccessModal.vue?vue&type=script&lang=js&"
import style0 from "./RuleLinkSuccessModal.vue?vue&type=style&index=0&id=60f37f77&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports